import './ManagePayment.less';
import {
  Row,
  Col,
  Divider,
  // Card,
  // Button,
  Collapse,
  Grid,
} from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import payment from 'assets/images/policy/payment.svg';
import history from 'assets/images/policy/history.svg';
import Edit from 'assets/images/policy/Edit.svg';

const { Panel } = Collapse;
import ChevronRight from 'assets/images/home/chevron-right.svg';
import ArrowClose from 'assets/images/home/arrow-close.svg';
import ChevronUp from 'assets/images/home/chevron-up.svg';
import { useNavigate } from 'react-router-dom';
const { useBreakpoint } = Grid;

interface DividerLineProps {
  padB?: string;
  marT?: string;
}
interface ManagePaymentProps {
  salesUnitCode?: string;
  policyStatusCode?: string;
  alertStateCode?: string;
  hiddenChangePaymentFlag?: string;
  policyNo?: string;
}
interface PdRowProps {
  paddingFlag?: string;
  padB?: string;
}
const StyledBlock = styled.div`
  width: 100%;
  background: #fff;
  margin-bottom: 1rem;
`;
const Androw = styled(Row)<PdRowProps>`
  max-width: 672px;
  margin: 0 auto;
  padding-top: ${(props) => (props.paddingFlag ? props.paddingFlag : `0`)};
  padding-bottom: ${(props) => (props.padB ? props.padB : `0`)};
`;
const AndCol = styled(Col)`
  // margin: 0 16px;
`;
const FlexCol = styled(Col)<{ flag?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: ${(props) => (props.flag ? '0 16px' : '0')};
`;
const AntDivider = styled(Divider)`
  border-color: #cccccc;
`;
const DividerLine = ({ padB, marT }: DividerLineProps) => {
  return (
    <Androw justify="start" padB={padB}>
      <AndCol style={{ width: '100%' }}>
        <AntDivider style={{ margin: '8px 0', marginTop: marT ? marT : '8px' }}></AntDivider>
      </AndCol>
    </Androw>
  );
};
const ManagePayment = ({
  salesUnitCode,
  alertStateCode,
  policyStatusCode,
  hiddenChangePaymentFlag,
  policyNo,
}: ManagePaymentProps): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { lg } = useBreakpoint();
  const gotoMore = (type?: string) => {
    if (type == 'payment') {
      //跳转到payment
      navigate('/LIPayment', {
        state: {
          tabs: 0,
        },
      });
    } else if (type == 'history') {
      //跳转到History
      navigate('/LIPayment', {
        state: {
          tabs: 1,
          policyNumber: policyNo,
        },
      });
    } else {
      //跳转到View/Change Payment Arrangement
      navigate('/ChangePaymentArrangement', { state: { policyNo } });
    }
  };
  const ExpandContent = () => {
    return (
      <div className="managePayment-content">
        {salesUnitCode?.trim() != 'ZAL' &&
          (policyStatusCode == 'MP' || policyStatusCode == 'IF' || policyStatusCode == 'AP') &&
          (alertStateCode == 'Due' || alertStateCode == 'Overdue' || alertStateCode == 'LevyOverdue') && (
            <>
              <Androw justify="space-between" style={{ maxWidth: '620px', margin: 0 }}>
                <AndCol span={18} style={{ cursor: 'pointer' }} onClick={() => gotoMore('payment')}>
                  <Androw justify="start">
                    <FlexCol style={{ alignItems: 'baseline' }}>
                      <AndCol>
                        <img src={payment} alt="" />
                      </AndCol>
                      <AndCol style={{ marginLeft: '12px' }}>
                        <p className={`${lg ? 'font-size20' : 'font-size17'}`} style={{ marginBottom: '12px' }}>
                          {t('life.policies.MakePayment')}
                        </p>
                        <p className={`p-bottom grey-font ${lg ? 'font-size17' : 'font-size15'}`}>
                          {t('life.policies.Makepaymentpolicy')}
                        </p>
                      </AndCol>
                    </FlexCol>
                  </Androw>
                </AndCol>
                <AndCol span={1}>
                  <img src={ChevronRight} alt="" />
                </AndCol>
              </Androw>
              <DividerLine></DividerLine>
            </>
          )}
        <Androw justify="space-between" style={{ maxWidth: '620px', margin: 0 }}>
          <AndCol span={18} style={{ cursor: 'pointer' }} onClick={() => gotoMore('history')}>
            <Androw justify="start">
              <FlexCol style={{ alignItems: 'baseline' }}>
                <AndCol>
                  <img src={history} alt="" />
                </AndCol>
                <AndCol style={{ marginLeft: '12px' }}>
                  <p className={`${lg ? 'font-size20' : 'font-size17'}`} style={{ marginBottom: '12px' }}>
                    {t('life.policies.PaymentHistory')}
                  </p>
                  <p className={`p-bottom grey-font ${lg ? 'font-size17' : 'font-size15'}`}>
                    {t('life.policies.SeePaymentHistory')}
                  </p>
                </AndCol>
              </FlexCol>
            </Androw>
          </AndCol>
          <AndCol span={1}>
            <img src={ChevronRight} alt="" />
          </AndCol>
        </Androw>
        <DividerLine></DividerLine>
        {hiddenChangePaymentFlag == 'Y' && (
          <>
            <Androw justify="space-between" style={{ maxWidth: '620px', margin: 0 }}>
              <AndCol span={18} style={{ cursor: 'pointer' }} onClick={() => gotoMore('arrangement')}>
                <Androw justify="start">
                  <FlexCol style={{ alignItems: 'baseline' }}>
                    <AndCol>
                      <img src={Edit} alt="" />
                    </AndCol>
                    <AndCol style={{ marginLeft: '12px' }}>
                      <p className={`${lg ? 'font-size20' : 'font-size17'}`} style={{ marginBottom: '12px' }}>
                        {t('life.policies.PaymentArrangement')}
                      </p>
                      <p className={`p-bottom grey-font ${lg ? 'font-size17' : 'font-size15'}`}>
                        {t('life.policies.RequestChange')}
                      </p>
                    </AndCol>
                  </FlexCol>
                </Androw>
              </AndCol>
              <AndCol span={1}>
                <img src={ChevronRight} alt="" />
              </AndCol>
            </Androw>
            <DividerLine></DividerLine>
          </>
        )}
      </div>
    );
  };
  return (
    <div className="managePayment-wrapper">
      <StyledBlock>
        <Androw justify="start">
          <AndCol style={{ width: '100%' }}>
            <Collapse
              className="font-size26 grey-font"
              style={{ backgroundColor: '#fff' }}
              collapsible="header"
              bordered={false}
              expandIconPosition="end"
              expandIcon={({ isActive }) => {
                return isActive ? <img src={ChevronUp} /> : <img src={ArrowClose} />;
              }}
            >
              <Panel header={t('life.policies.ManagePayment')} key="1" className="grey-font">
                <ExpandContent></ExpandContent>
              </Panel>
            </Collapse>
          </AndCol>
        </Androw>
      </StyledBlock>
    </div>
  );
};

export default ManagePayment;
